var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrouponProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0d900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23129,
    stopColor: "#5ec000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#00a400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99468,
    stopColor: "#005400"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.14744,33.16937l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.46842,41.42247l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.37513,51.40557l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.74738,56.63693c-1.7412-5.16041-7.38948-9.27961-14.32432-7.58637-6.44454,1.57353-10.26812,8.238-8.61957,14.89059,1.61016,6.49768,8.22074,10.43561,14.7309,8.70844,6.59618-1.75,9.68973-7.70765,8.87313-13.10883h-13.248v4.47434h6.66787c-.83415,1.84849-2.90923,3.16641-4.83387,3.29859-4.36153.29956-7.5491-4.06947-6.55939-8.12254,1.15457-4.72824,6.8048-6.37506,10.3873-3.06075.23229.2149.54542.47848.82585.4843,2.00714.04161,4.01555.02223,6.1001.02223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.74738,56.63693c-2.08455,0-4.09296.01938-6.1001-.02223-.28043-.00581-.59355-.26939-.82585-.4843-3.5825-3.31431-9.23272-1.66748-10.3873,3.06075-.98971,4.05307,2.19786,8.4221,6.55939,8.12254,1.92464-.13219,3.99972-1.4501,4.83387-3.29859h-6.66787v-4.47434h13.248c.81659,5.40118-2.27695,11.35884-8.87313,13.10883-6.51016,1.72717-13.12074-2.21076-14.7309-8.70844-1.64855-6.65259,2.17503-13.31707,8.61957-14.89059,6.93484-1.69324,12.58312,2.42597,14.32432,7.58637Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouponProductsScraper);
export default __webpack_public_path__ + "static/media/groupon-products-scraper.20a1238784eeeecf19fb1c948639fdf9.svg";
export { ForwardRef as ReactComponent };